<template>
  <div>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12">
        <exercise-logic-multiple
          exCollection="deliverablesExCollection"
          refCollection=""
          @ready="onReady"
          @error="onError"
          @saved="onSaved"
          @savedNext="onSavedNext"
          @loadedEx="onLoadedEx"
          @modifyEx="onModifyEx"
          @loadedRef="onLoadedRef"
          :doc="doc"
          :shared="true"
          :projectShared="false"
          :pid="true"
          :synced="false"
          :saveState="saveState"
        >
          <template slot-scope="{ saveExercise }">
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step
                  color="amber"
                  :complete="e1 > 1"
                  step="1"
                  @click="el = 1"
                  >Assets</v-stepper-step
                >
                <v-divider></v-divider>
              </v-stepper-header>

              <v-stepper-items>
                <!-- Step 1 -->
                <v-stepper-content step="1">
                  <v-row>
                    <v-col cols="4" class="mb-4">
                      <h2
                        class="headline"
                        v-text="$t('exercise_deliverables.step1.title')"
                      ></h2>
                    </v-col>

                    <v-col cols="8" class="">
                      <p
                        v-for="(item, index) in $t(
                          'exercise_deliverables.step1.description'
                        )"
                        :key="index"
                        v-text="item"
                      />
                    </v-col>
                  </v-row>

                  <v-row v-if="doc">
                    <v-col cols="12" offset="0">
                      <v-row>
                        <v-col cols="4">
                          <v-card>
                            <v-card-text>
                              <unit-items
                                v-model="doc.categories.q6"
                                name="categories.q6"
                                title="Core"
                                @autosave="doAutoSave"
                              ></unit-items> </v-card-text
                          ></v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card>
                            <v-card-text>
                              <unit-items
                                v-model="doc.categories.q1"
                                name="categories.q1"
                                title="Film / Video"
                                @autosave="doAutoSave"
                              ></unit-items>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card>
                            <v-card-text>
                              <unit-items
                                v-model="doc.categories.q2"
                                name="categories.q2"
                                title="Digital"
                                @autosave="doAutoSave"
                              ></unit-items> </v-card-text
                          ></v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card>
                            <v-card-text>
                              <unit-items
                                v-model="doc.categories.q3"
                                name="categories.q3"
                                title="Experience"
                                @autosave="doAutoSave"
                              ></unit-items> </v-card-text
                          ></v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card>
                            <v-card-text>
                              <unit-items
                                v-model="doc.categories.q4"
                                name="categories.q4"
                                title="Publications"
                                @autosave="doAutoSave"
                              ></unit-items> </v-card-text
                          ></v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card>
                            <v-card-text>
                              <unit-items
                                v-model="doc.categories.q5"
                                name="categories.q5"
                                title="Internal"
                                @autosave="doAutoSave"
                              ></unit-items> </v-card-text
                          ></v-card>
                        </v-col>
                        <v-col cols="12">
                          <v-card>
                            <v-card-text>
                              <unit-items
                                v-model="doc.categories.q5"
                                name="categories.q7"
                                title="Other"
                                @autosave="doAutoSave"
                              ></unit-items> </v-card-text
                          ></v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <bottom-navigation
                    :save="true"
                    :next="false"
                    :prev="false"
                    :gridView="false"
                    :gridToggle="false"
                    @save="saveExercise(true)"
                    @prev="prevStep"
                    @next="saveExercise(false)"
                  >
                  </bottom-navigation>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </template>
        </exercise-logic-multiple>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title
          class="headline"
          v-text="$t('exercise_service.saved.title')"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'add'">
        <v-card-title>Add note</v-card-title>

        <v-card-text>
          <activation-add @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card light v-if="dialogMode == 'show'">
        <v-card-text class="pa-10">
          <activation-show :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == 'edit'">
        <v-card-title class="headline">Edit note</v-card-title>

        <v-card-text>
          <activation-edit :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-else>
        <v-card-title
          class="headline"
          v-text="$t('exercise_functionality.saved.title')"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="amber black--text" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn color="amber accent-1 black--text" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogicMultiple } from "@/components/exercises";

import { UnitItems } from "@/components/units";

// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserArchitecture",
  data() {
    return {
      e1: 1,
      exercises: null,
      refs: null,
      dialog: false,
      dialogMode: "add",
      allItems: null,
      saveState: false,
      autoSave: true,
      listName: "",
      results: {
        audience: [],
        features: [],
        benefits: [],
        reasons: [],
      },
      doc: {
        categories: {
          q1: [],
          q2: [],
          q3: [],
          q4: [],
          q5: [],
          q6: [],
          q7: [],
        },
        list: {},
        listNames: [],
        allItems: [],
        audienceAll: [],
        contentAll: [],
      },
      listLength: 1,
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogicMultiple,
    UnitItems,
  },
  watch: {
    e1(val) {
      if (val === 3) {
        this.createList();
      }
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  mounted() {},

  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved ex");
      this.dialogMode = "";
      this.dialog = true;
    },
    onLoadedRef() {},
    onLoadedEx(items) {
      console.log("loaded exercises", items);
      // this.doc = items[0].doc;
      if (items) {
        this.mergeArrays(items[0].doc);
      }
    },
    onModifyEx(items) {
      // console.log("modify exercises", items);
      this.exercises = [...items];
    },
    onSavedNext() {
      // this.nextStep();
      console.log("save next");
      this.saveState = false;
    },
    addIdea() {
      this.dialogMode = "add";
      this.dialog = true;
    },
    pushToArray(arr, model, color) {
      if (arr || arr.length > 0 || arr != undefined) {
        arr.forEach((y) => {
          this.results[model].push({ title: y, color: color });
        });
      }
    },
    addList() {
      // let l = Object.keys(this.doc.list).length + 1;
      let lc = this.listName.replace(/\s/g, "").toLowerCase();
      this.doc.listNames.push({ title: this.listName, name: lc });
      this.listName = "";
      this.$set(this.doc.list, lc, []);
    },
    clone(obj) {
      Object.assign({}, obj);
    },
    renameKey(object, key, newKey) {
      const clonedObj = this.clone(object);
      const targetKey = clonedObj[key];
      delete clonedObj[key];
      clonedObj[newKey] = targetKey;
      return clonedObj;
    },
    mergeArrays(arr) {
      Object.entries(arr).forEach(([outerKey, value]) => {
        Object.entries(value).forEach(([key, value]) => {
          this.doc[outerKey][key] = value;
        });
      });
    },
    addNote() {
      this.dialogMode = "add";
      this.dialog = true;
    },
    editNote($event) {
      console.log("edit note", $event);
      this.dialogMode = "edit";
      this.cardId = $event;
      this.dialog = true;
    },
    showNote($event) {
      console.log("show note", $event);
      this.dialogMode = "show";
      this.cardId = $event;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
    },
    createList() {
      let items = [];
      Object.values(this.doc.audience).forEach((value) => {
        value.forEach((x) => {
          x.color = "blue lighten-4";
          items.push(x);
        });
      });
      Object.values(this.doc.content).forEach((value) => {
        value.forEach((x) => {
          x.color = "lime accent-1";
          items.push(x);
        });
      });
      let itemsFromList = [];
      Object.values(this.doc.list).forEach((value) => {
        value.forEach((x) => {
          itemsFromList.push(x);
        });
      });
      let all = [];
      items.forEach((x) => {
        if (!itemsFromList.some((y) => y.title == x.title)) {
          all.push(x);
        }
      });
      this.doc.allItems = all;
    },
    doAutoSave() {
      if (this.autoSave) {
        this.saveState = true;
      }
    },
  },
};
</script>

<style lang="scss"></style>
